import { useSelector } from 'react-redux';

import { selectors as helpCenterSelectors } from '../../../../../redux/help-center-page';

const useData = () => useSelector(helpCenterSelectors.selectData);

const hooks = { useData };

export default hooks;
